<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Clinics",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Clinics",
            items: [
               {
                  text: "Clinics",
                  active: true,
               },                   
            ],

            clinics: [],
            clinic_status: {
               id: "",
               status: "",
            },
            listing_length: 10,
            keyword: '',
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
         };
      },
      mounted() {
    
      },

      methods: {
         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">                        
                        <router-link :to="{ name: 'clinics.add' }" class="btn btn-primary float-end">Add Clinic</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="0">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th width="20%">Name</th>  
                              <th width="15%">Place</th> 
                              <th width="15%">Phone</th> 
                              <th width="20%">Created On</th>
                              <th width="30%">Options</th>
                           </tr>
                        </thead>

                        <tbody>
                           <tr>
                              <td>Clinic 1</td>
                              <td>Kochi</td>
                              <td>1234567890</td>
                              <td>11 Nov 2021, 04:25 pm</td>
                              <td>
                                 <router-link :to="{ name: 'clinics.edit' }" class="btn btn-primary btn-sm me-2 mb-2">Edit</router-link>
                                 <router-link :to="{ name: 'clinics.doctors' }" class="btn btn-primary btn-sm me-2 mb-2">Doctors</router-link>
                                 <b-button variant="danger" class="btn-sm me-2 mb-2" >Unpublish</b-button>
                              </td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->   
                  <caption class="float-start mt-4 d-block d-lg-inline">Showing 1 to 10 of 26 entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item disabled">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-left"></i>
                        </a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">1</a>
                     </li>
                     <li class="page-item active">
                        <a href="#" class="page-link">2</a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">3</a>
                     </li>
                     
                     <li class="page-item">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-right"></i>
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

              

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
